import React, { Component } from 'react';
import PropTypes from 'prop-types';


class Button extends Component {

    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {

        let {buttonStyle, buttonLabel, buttonType, className,buttonIcon, ...rest} = this.props;

        var defaultClassName = 'imem-button';
        // Append the buttonStyle prop for color changes or disabled states.
        if(buttonStyle){ defaultClassName += ` ${buttonStyle}` }
        // Append user assigned className prop
        if(className){ defaultClassName += ` ${className}` }
        let buttonIconImg = buttonIcon == null ? null:<img src={buttonIcon} className={"imem-button-icon"} alt="icon"/>
        return (
            <button {...rest} type={buttonType!=null? buttonType: 'button'} className={defaultClassName}>{buttonIconImg}{buttonLabel}</button>
        );

    }

}

Button.propTypes = {
    buttonLabel: PropTypes.string,
    buttonStyle: PropTypes.oneOf(['primary', 'secondary', 'tertiary','link']),
    buttonType: PropTypes.oneOf(['button', 'submit', 'reset' ]),
    buttonIcon: PropTypes.string,
    className: PropTypes.string
};

export default Button;


// WEBPACK FOOTER //
// ./src/common/components/button.jsx